export default "__VITE_ASSET__534908bb__"